module.exports = __webpack_public_path__ + "static/media/clippy.23d81dcc.png";